import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors, frames, glyphs } from '../../../Styles';
import { CheckBox, CheckStyles, NewCreatableSelect, NewInput, PageHeader } from '../../../Components';
import { Pages } from '../../../Navigation/Routers/root';
import LanguageSelector from '../../../Components/languageSelector';
import NewTimePicker from '../../../Components/BaseComponents/newTimePicker';
import FeedSkipPopover from '../../../Components/LocationFeeder/feedSkipPopover';

export default function Dashboard() {
  const { t } = useTranslation();

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <PageHeader topHeader={t(`menuHeaders.${Pages.dashboard}`, {defaultValue: "dashboard"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})} />
      </frames._page_inner_header>
      
      <frames._page_inner_content_scroll>
      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}
